import { useTheme } from '@mui/material';
import { useMemo } from 'react';
import { IStep, StatusEnum } from '@diana/core';

export function useColor({ step }: { step: IStep }) {
  const { palette } = useTheme();
  return useMemo(() => {
    switch (step.status) {
      case StatusEnum.NEW:
      case StatusEnum.CREATED:
        return palette.text.secondary;
      default:
        return palette.text.primary;
    }
  }, [step.status, palette.text.primary, palette.text.secondary]);
}
